type FilterItem = { label: string; count: number };

export const useGetStatusCount = (statuses: any) => {
  let result: FilterItem[] = [];
  if (statuses) {
    const _val = Object.entries(statuses);
    _val.forEach((item: any) => {
      result.push({ label: item[0].toUpperCase(), count: item[1] });
    });

    const all = result.reduce(function (accumulator, currentValue) {
      return accumulator + currentValue.count;
    }, 0);

    const sorted: FilterItem[] = result.sort((a: FilterItem, b: FilterItem) =>
      a.label.localeCompare(b.label),
    );
    sorted.unshift({ label: "ALL", count: all });

    result = sorted;
  }

  return result;
};
